import { Card, CollapsibleText, Flex, Icon, Space, Tag, Text } from "components/common"
import { IconText, Separator } from "components/custom"
import { useTranslation } from "react-i18next"
import { capitalizeFirstLetter, joinBytItems, localisedValue } from "utils"
import DateTime from "utils/dateTime"
import theme from "utils/themeVars"
import styles from "./SalesPlaybook.module.less"
import dayjs from "dayjs"

const LastEngagement = ({ engagement }) => {
  const { t } = useTranslation()
  if (!engagement || typeof engagement !== "object") return null
  const hasScore =
    engagement?.score !== undefined &&
    engagement?.score !== null &&
    engagement?.maxScore !== undefined &&
    engagement?.maxScore !== null
  const summary = localisedValue({ object: engagement, key: "summary" }) || ""
  const activityType = capitalizeFirstLetter(engagement?.activityType) || ""

  const dateString = engagement?.date ? (
    <IconText icon="BiTimeFive" title={DateTime.fromDateAndTime(engagement?.date)} />
  ) : (
    ""
  )

  const duration = dayjs.duration(engagement?.callDuration, "seconds")

  const durationString = !!engagement?.callDuration ? (
    <IconText icon="BiTimer" title={`${duration.asMinutes()} Min ${duration.seconds()} Sec`} />
  ) : (
    ""
  )

  const headerItems = [activityType, dateString, durationString].filter(Boolean)

  if (!engagement || typeof engagement !== "object") return null
  return (
    <Card Shadow={false} className={styles.lastEngagementCard}>
      <Flex justify="space-between" align="center" className={styles.lastEngagementHeader}>
        <Flex align="center" gap={8}>
          <IconText
            icon="AiOutlineCalendar"
            iconProps={{ size: 18, style: { color: theme["accent-color"] } }}
            title={
              <Flex align="center" gap={"6px"}>
                <Text strong className="fs16">
                  {t("Last Engagement")}
                </Text>
                {headerItems.length > 0 && (
                  <Text type="secondary">
                    ({joinBytItems(headerItems, <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />)})
                  </Text>
                )}
              </Flex>
            }
          />
        </Flex>

        {hasScore && (
          <Tag color={theme["accent-color-light"]} className={styles.scoreTag}>
            <Space size={4}>
              <Text className="fw-medium" style={{ color: theme["accent-color"] }}>
                {t("Score")}:
              </Text>
              <Text className="fw-medium" style={{ color: theme["accent-color"] }}>
                {engagement.score}/{engagement.maxScore}
              </Text>
            </Space>
          </Tag>
        )}
      </Flex>

      {summary && (
        <div className={styles.lastEngagementContent}>
          <CollapsibleText text={summary} collapsibleLength={150} className={styles.engagementDescription} />
        </div>
      )}
    </Card>
  )
}

export default LastEngagement
